var exports = {
  "k": "xe564cbfb--97bc18--container",
  "y": "xe564cbfb--97bc18--links",
};

module.exports = exports;
